/**
 * Liga a elevação única dos blocos da thread (`--shadow-elevation`, #6296) nos cards do
 * intelligence-ui-kit que também moram fora dela — oferta de voo, ônibus e carro, quarto,
 * mapa do hotel, planner de voo, serviços seguintes — e na casca `.cd`, que o card de datas
 * divide com o planner. Eles leem `--block-elevation` e, sem ela, ficam com a casca de fora
 * (explorer, bancada, gaveta, "Solicitação enviada").
 *
 * Vai na raiz do kind que monta esses cards, nunca numa tela: a propriedade herda, e as
 * camadas que o kind abre (diálogo, gaveta, side panel) saem por portal, fora do alcance.
 */
export const BLOCK_ELEVATION = '[--block-elevation:var(--shadow-elevation)]';
